import AuthReducer from './auth-reducer'

export default {
    auth: AuthReducer,
}
